module.exports = __webpack_public_path__ + "img/6.6753b823.webp";